/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptAd } from '../models/V3StackAdaptAd';
import { V3StackAdaptAudience } from '../models/V3StackAdaptAudience';
import { V3StackAdaptBidFactor } from '../models/V3StackAdaptBidFactor';
import { V3StackAdaptCampaignFlight } from '../models/V3StackAdaptCampaignFlight';
import { V3StackAdaptCampaignGoal } from '../models/V3StackAdaptCampaignGoal';
import { V3StackAdaptCreativeTactic } from '../models/V3StackAdaptCreativeTactic';
import { V3StackAdaptGeoTargeting } from '../models/V3StackAdaptGeoTargeting';
import { V3StackAdaptInventoryConfig } from '../models/V3StackAdaptInventoryConfig';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { HttpFile } from '../http/http';

/**
* A specific campaign configuration in StackAdapt
*/
export class V3StackAdaptCampaignConfig {
    /**
    * Campaign ID
    */
    'id'?: string;
    /**
    * Campaign name
    */
    'name'?: string;
    /**
    * Advertiser ID
    */
    'advertiserId'?: string;
    /**
    * Campaign group ID
    */
    'campaignGroupId'?: string;
    /**
    * Goal type for the campaign
    */
    'goalType'?: string;
    /**
    * Whether campaign is draft
    */
    'isDraft'?: boolean;
    /**
    * Ads configuration
    */
    'ads'?: Array<V3StackAdaptAd>;
    'audience'?: V3StackAdaptAudience;
    /**
    * Flights configuration
    */
    'flights'?: Array<V3StackAdaptCampaignFlight>;
    /**
    * User metadata for the campaign
    */
    'userMetadata'?: Array<V3StackAdaptUserMetadata>;
    'geo'?: V3StackAdaptGeoTargeting;
    'inventory'?: V3StackAdaptInventoryConfig;
    /**
    * Subtype for a campaign. Must be one of 'DEFAULT', 'INGAME', 'LIVE_EVENTS', 'OTT', 'STATIC', 'VIDEO'
    */
    'subtype'?: string;
    /**
    * Bid Factor configuration for the campaign
    */
    'bidFactors'?: Array<V3StackAdaptBidFactor>;
    'campaignGoal'?: V3StackAdaptCampaignGoal;
    /**
    * Creative tactics configuration for the campaign
    */
    'creativeTactics'?: Array<V3StackAdaptCreativeTactic>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiserId",
            "baseName": "advertiserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignGroupId",
            "baseName": "campaignGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "goalType",
            "baseName": "goalType",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDraft",
            "baseName": "isDraft",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ads",
            "baseName": "ads",
            "type": "Array<V3StackAdaptAd>",
            "format": ""
        },
        {
            "name": "audience",
            "baseName": "audience",
            "type": "V3StackAdaptAudience",
            "format": ""
        },
        {
            "name": "flights",
            "baseName": "flights",
            "type": "Array<V3StackAdaptCampaignFlight>",
            "format": ""
        },
        {
            "name": "userMetadata",
            "baseName": "userMetadata",
            "type": "Array<V3StackAdaptUserMetadata>",
            "format": ""
        },
        {
            "name": "geo",
            "baseName": "geo",
            "type": "V3StackAdaptGeoTargeting",
            "format": ""
        },
        {
            "name": "inventory",
            "baseName": "inventory",
            "type": "V3StackAdaptInventoryConfig",
            "format": ""
        },
        {
            "name": "subtype",
            "baseName": "subtype",
            "type": "string",
            "format": ""
        },
        {
            "name": "bidFactors",
            "baseName": "bidFactors",
            "type": "Array<V3StackAdaptBidFactor>",
            "format": ""
        },
        {
            "name": "campaignGoal",
            "baseName": "campaignGoal",
            "type": "V3StackAdaptCampaignGoal",
            "format": ""
        },
        {
            "name": "creativeTactics",
            "baseName": "creativeTactics",
            "type": "Array<V3StackAdaptCreativeTactic>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCampaignConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

